const Config = {
    maincolor: '#0D1134',
    textcolor: '#b0D1134',
    secondcolor: '#FFCC3E',
    api :  "https://app.himoralanguagecenter.com/api/v1",
    // api :  "http://192.168.1.21/api/v1",
    base :  "https://app.himoralanguagecenter.com",
    // base :  "http://192.168.1.21",
    meet :  "https://meet.himoralanguagecenter.com",
    // base :  "http://192.168.1.14",
    dl :  "https://dl.himoralanguagecenter.com",
    version :  17,
}

export default Config;